import { Button, ConfirmationModal } from 'components/common';

interface FinmoConnectionProps {
  hasBrokerage: boolean;
  hasPlatinumSubscription: boolean;
  onDisconnect: () => void;
  onHideModal: () => void;
  onShowDisconnectFinmoModal: () => void;
  showModal: boolean;
}

const FinmoConnection = ({
  hasBrokerage,
  hasPlatinumSubscription,
  onDisconnect,
  onHideModal,
  onShowDisconnectFinmoModal,
  showModal,
}: FinmoConnectionProps) => (
  <div className="card" data-testid="subscriptions-finmo-connection-card">
    <ConfirmationModal
      confirmButtonText="Disconnect"
      handleConfirmation={onDisconnect}
      hideModal={onHideModal}
      isConfirmDangerous
      showModal={showModal}
      title="Disconnect Finmo account"
    >
      {hasBrokerage ? (
        <div>
          As you have access to Platinum features through your team, you will not lose access by disconnecting your
          Finmo account. If you want to re&#45;connect your Finmo account, you will need to contact customer support.
        </div>
      ) : hasPlatinumSubscription ? (
        <div>
          As you have a Platinum subscription, you will not lose access by disconnecting your Finmo account. If you want
          to re&#45;connect your Finmo account, you will need to contact customer support.
        </div>
      ) : (
        <>
          <div>
            Disconnecting your Finmo account will remove your access to Platinum features, and any active add&#45;ons
            will be cancelled immediately.
          </div>
          <div className="my-4">
            Purchase a Platinum subscription before disconnecting your Finmo account to preserve feature access.
          </div>
        </>
      )}
    </ConfirmationModal>
    <div className="card-body">
      <h4 className="fw-bold mb-2">Finmo Connection</h4>
      <div className="my-3">
        Your Lender Spotlight account is connected to your Finmo account. This connection gives you access to Platinum
        features in Lender Spotlight.
      </div>
      <Button
        onClick={onShowDisconnectFinmoModal}
        testId="subscriptions-finmo-connection-disconnect-button"
        text="bold"
        variant="danger"
      >
        Disconnect Finmo account
      </Button>
    </div>
  </div>
);

export default FinmoConnection;
